import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { DeliveryChallan, DeliveryChallanCreate, DeliveryChallanFilter } from '../data/deliveryChallan';

export function createDeliveryChallanService(client: AxiosInstance) {
  return createCrudService<DeliveryChallan, DeliveryChallanCreate, DeliveryChallanFilter>(
    client,
    '/sales/DeliveryChallan',
    'id',
  );
}

export type DeliveryChallanService = CrudService<DeliveryChallan, DeliveryChallanCreate, DeliveryChallanFilter>;
